import React from 'react';
import PropTypes from 'prop-types';
import { withFormik, FieldArray } from 'formik';
import CheckboxInput from '../../Global/Forms/CheckboxInput';
import Button from '../../Global/Buttons/Button';
import Form from "../../Global/Forms/Form";

const ChangeAgePreferencesForm = ({
  agePreferences,
  ageCategories,
  submitting,
  // Formik props
  values,
}) => {
  const hasFormChanged = () => {
    if (agePreferences === values.coachAgeGroups) {
      return false;
    }
    return true;
  };

  return (
    <Form className="m-b-5">
      <h3 className="like-h3 m-b-3">Age Groups You Coach</h3>

      <fieldset className="m-b-5">
        <div className="form-group form-inline">
          <span className="faux-label">Age groups you coach</span>
          <p className="like-small color-grey">Choosing will help us tailor content and search</p>

          <FieldArray
            name="coachAgeGroups"
            render={arrayHelpers => (
              <div className="form-inline__field-container">
                {ageCategories.map(coachAge => (
                  <CheckboxInput
                    key={coachAge.id}
                    name="coachAgeGroups"
                    label={coachAge.name}
                    value={coachAge.id}
                    checked={values.coachAgeGroups.includes(coachAge.id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        arrayHelpers.push(coachAge.id);
                      } else {
                        const value = values.coachAgeGroups.indexOf(coachAge.id);
                        arrayHelpers.remove(value);
                      }
                    }}
                  />
                ))}
              </div>
            )}
          />
        </div>

        <div className="text-right form-group">
          <Button type="submit" loading={submitting} disabled={hasFormChanged() === false}>Change age groups</Button>
        </div>
      </fieldset>
    </Form>
  );
};

ChangeAgePreferencesForm.propTypes = {
  agePreferences: PropTypes.array.isRequired,
  ageCategories: PropTypes.array.isRequired,
  submitting: PropTypes.bool.isRequired,
  // Formik
  values: PropTypes.object.isRequired,
};

const FormikChangeAgePreferencesForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues({ agePreferences }) {
    return {
      coachAgeGroups: agePreferences || [],
    };
  },
  handleSubmit(values, bag) {
    bag.props.onSubmit(values);
  },
})(ChangeAgePreferencesForm);

export default FormikChangeAgePreferencesForm;



// WEBPACK FOOTER //
// ./library/app/components/Account/AccountDetails/ChangeAgePreferencesForm.js